module.exports = __webpack_public_path__ + "static/img/brees-2006-slide-6.ca78270.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2006-slide-6.jpg
// module id = Mjte
// module chunks = 1